import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-503e36a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex w-full h-full overflow-hidden" };
const _hoisted_2 = { class: "flex flex-row items-center mb-2 px-4 mt-2 justify-between" };
const _hoisted_3 = { class: "hidden md:block" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-plus mr-2" }, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", { class: "block md:hidden fas fa-plus" }, null, -1));
const _hoisted_6 = { class: "flex flex-row items-center pl-2" };
const _hoisted_7 = { class: "pl-3 font-bold" };
const _hoisted_8 = { class: "flex flex-row items-center pl-2" };
const _hoisted_9 = {
    key: 0,
    class: "flex flex-row items-center hidden md:flex"
};
const _hoisted_10 = { class: "capitalize" };
const _hoisted_11 = {
    key: 0,
    class: "w-full md:w-3/4"
};
export function render(_ctx, _cache) {
    const _component_search_bar = _resolveComponent("search-bar");
    const _component_Button = _resolveComponent("Button");
    const _component_avatar = _resolveComponent("avatar");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_Table = _resolveComponent("Table");
    const _component_user_sidebar = _resolveComponent("user-sidebar");
    const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col w-full h-full overflow-hidden", { block: !!_ctx.selectedUser }])
        }, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_search_bar, {
                    lazy: "",
                    searchValue: _ctx.userSearch,
                    "onUpdate:searchValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userSearch) = $event)),
                    class: "w-full max-w-md"
                }, null, 8, ["searchValue"]),
                (!_ctx.isAppPreregistrationEnabled)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "m-0",
                        colored: "",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('showInvitation')))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.new')), 1)
                            ]),
                            _hoisted_5
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_Table, {
                class: "mb-2",
                "default-sort": _ctx.sortedField,
                "onUpdate:default-sort": _cache[2] || (_cache[2] = ($event) => ((_ctx.sortedField) = $event)),
                headers: _ctx.headers,
                data: _ctx.users,
                "backend-pagination-sorting": "",
                onSortChanged: _ctx.sortUsers,
                selectable: "",
                onSelectedChanged: _ctx.selectedChanged,
                emptyMessage: _ctx.$t('filter.usersNotFound'),
                "is-loading": _ctx.isLoading
            }, {
                "data-username": _withCtx((originalData) => [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_avatar, {
                            rounded: "",
                            class: "hidden md:block h-12 w-12",
                            "round-size": "full",
                            src: `https://picsum.photos/seed/${originalData.row.id}/300/300`
                        }, null, 8, ["src"]),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(originalData.row.username), 1)
                    ])
                ]),
                "data-vaults": _withCtx((originalData) => [
                    _createElementVNode("div", _hoisted_8, [
                        (originalData.row.role !== _ctx.Role.ADMIN)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originalData.row.spaces, (space) => {
                                    return (_openBlock(), _createBlock(_component_avatar, {
                                        key: space.id,
                                        class: "h-8 w-8",
                                        src: `https://picsum.photos/seed/${space.id}/300/300`,
                                        "round-size": "full h-8 w-8"
                                    }, null, 8, ["src"]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                tableEmptyState: _withCtx(() => [
                    _createVNode(_component_empty_table_state, null, _createSlots({
                        icon: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent("usersNavigationIcon"), { class: "h-8 w-8 mx-auto text-gray-400" }))
                        ]),
                        header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('filter.usersNotFound')), 1)
                        ]),
                        _: 2
                    }, [
                        (_ctx.userSearch === '')
                            ? {
                                name: "content",
                                fn: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('filter.userInviteMessage')), 1)
                                ])
                            }
                            : undefined
                    ]), 1024)
                ]),
                loading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tables.loadingState.userLoading')) + "... ", 1)
                ]),
                "data-role": _withCtx((originalData) => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(originalData.row.role), 1)
                ]),
                _: 1
            }, 8, ["default-sort", "headers", "data", "onSortChanged", "onSelectedChanged", "emptyMessage", "is-loading"])), [
                [_directive_infinite_scroll, _ctx.getMoreUsers]
            ])
        ], 2),
        (_ctx.selectedUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(), _createBlock(_component_user_sidebar, {
                    key: _ctx.selectedUser.id,
                    selectedVaultUser: _ctx.selectedUser,
                    onEditUser: _cache[3] || (_cache[3] = ($event) => (_ctx.showEditUserModal(_ctx.selectedUser))),
                    onCollapseSidebar: _cache[4] || (_cache[4] = ($event) => (_ctx.selectedUser = undefined))
                }, null, 8, ["selectedVaultUser"]))
            ]))
            : _createCommentVNode("", true)
    ]));
}
